module.exports = __webpack_public_path__ + "media/images/athletes/25-1c9f388fe68b91515c9af4933368b247.png";